import React, { useState } from 'react';
import { Upload, Send, Image, AlertCircle, CheckCircle } from 'lucide-react';
import { getCookie } from '../../../utils/local_storing';
const UploadImage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        setError('Please select a valid image file');
        return;
      }
      
      setSelectedImage(file);
      setError(null);
      setResult(null);
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };



  const handleSendImage = async () => {
    if (!selectedImage) return;

    setIsLoading(true);
    setError(null);

    try {
      const urlParams = new URLSearchParams(window.location.search);
      const currentDomain = urlParams.get("parentUrl");
      const data_var = currentDomain + "myData";
      const storedData = getCookie(data_var);
      const parsedData = JSON.parse(storedData);
      const  docid = parsedData.key;
      const formData = new FormData();

      formData.append('file', selectedImage);
      formData.append('docid', docid);
  
      const response = await fetch('https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/analyze-skin-tone', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setResult(data);
    } catch (err) {
      setError(err.message || 'Failed to analyze skin tone. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageClick = () => {
    document.getElementById('image-upload').click();
  };

  return (
    <div className="krunk-w-4/5 krunk-mr-auto krunk-ml-[7px] krunk-mb-[0px] krunk-mt-[7px] krunk-p-6 krunk-bg-headercolor krunk-rounded-lg krunk-shadow-lg">
      {/* Header */}
      <div className="krunk-text-center krunk-mb-6">
        <p className=" krunk-text-[13px] krunk-text-bubbletext krunk-leading-relaxed">
          You can find your perfect makeup shade, using tool <a href="https://www.yaanman.in/pages/find-your-shade?utm_source=krunkai" className="krunk-text-blue-600 hover:krunk-text-blue-700 krunk-underline krunk-font-medium"> Click here</a> or can upload your selfie in natural light to help us find your perfect skin shade.
        </p>
      </div>

      {/* Hidden file input */}
      <input
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
        className="krunk-hidden"
        id="image-upload"
      />

      {/* Upload Section - Only show when no image is selected */}
      {!imagePreview && (
        <div className="krunk-mb-4">
          <label className="krunk-block krunk-text-bubbletext krunk-text-[13px]  krunk-mb-2">
            Upload Your Photo
          </label>
          
          <div 
            className="krunk-border-2 krunk-border-dashed krunk-border-gray-300 krunk-rounded-lg krunk-p-4 krunk-text-center hover:krunk-border-blue-400 krunk-transition-colors krunk-cursor-pointer"
            onClick={handleImageClick}
          >
            <Upload className="krunk-mx-auto krunk-h-8 krunk-w-8 krunk-text-gray-400 krunk-mb-2" />
            <p className="krunk-text-gray-600 krunk-text-xs krunk-mb-1">
              Upload your selfie here
            </p>
            <p className="krunk-text-xs krunk-text-gray-500">
              PNG, JPG, JPEG up to 10MB
            </p>
          </div>
        </div>
      )}

      {/* Image Preview - Clickable to change image */}
      {imagePreview && (
        <div className="krunk-mb-4">
          <label className="krunk-block krunk-text-sm krunk-font-medium krunk-text-gray-700 krunk-mb-2">
            Selected Image (Click to change)
          </label>
          <div className="krunk-relative krunk-bg-gray-50 krunk-rounded-lg krunk-p-3">
            <img
              src={imagePreview}
              alt="Selected"
              className="krunk-max-w-full krunk-max-h-32 krunk-mx-auto krunk-rounded-lg krunk-shadow-md krunk-cursor-pointer hover:krunk-opacity-80 krunk-transition-opacity"
              onClick={handleImageClick}
            />
          </div>
        </div>
      )}

      {/* Send Button - Smaller size */}
      {selectedImage && (
        <div className="krunk-mb-2 krunk-flex krunk-justify-center">
          <button
            onClick={handleSendImage}
            disabled={isLoading}
            className="krunk-krunk-bg-headercolor   krunk-text-black krunk-font-medium krunk-py-2 krunk-px-4 krunk-rounded-lg krunk-flex krunk-items-center krunk-space-x-2 krunk-transition-colors krunk-text-sm"
          >
            {isLoading ? (
              <>
                <div className="krunk-animate-spin krunk-rounded-full krunk-h-3 krunk-w-3 krunk-border-b-2 krunk-border-white"></div>
                <span>Analyzing...</span>
              </>
            ) : (
              <>
                <Send className="krunk-h-3 krunk-w-3" />
                <span>Analyze</span>
              </>
            )}
          </button>
        </div>
      )}

      {/* Error Message */}
      {error && (
        <div className="krunk-mb-4 krunk-bg-red-50 krunk-border krunk-border-red-200 krunk-rounded-lg krunk-p-3">
          <div className="krunk-flex krunk-items-center">
            <AlertCircle className="krunk-h-4 krunk-w-4 krunk-text-red-500 krunk-mr-2" />
            <p className="krunk-text-red-700 krunk-text-sm">{error}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadImage;